import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as DownArrowIcon } from "../../../../../assets/appearencePage/arrow-down.svg";
import { ReactComponent as DownArrowIconDark } from "../../../../../assets/appearencePage/arrow-down-dark.svg";
import { ReactComponent as Brush } from "../../../../../assets/appearencePage/brush.svg";
import { ReactComponent as BrushDark } from "../../../../../assets/appearencePage/brush-dark.svg";
import { ReactComponent as Outline } from "../../../../../assets/appearencePage/outlineIcon.svg";
import { ReactComponent as OutlineDark } from "../../../../../assets/appearencePage/outlineIcon-dark.svg";
import { ReactComponent as AnimationType } from "../../../../../assets/appearencePage/chart.svg";
import { ReactComponent as AnimationTypeDark } from "../../../../../assets/appearencePage/chart-dark.svg";
import { ReactComponent as AnimationRuns } from "../../../../../assets/appearencePage/timer.svg";
import { ReactComponent as AnimationRunsDark } from "../../../../../assets/appearencePage/timer-dark.svg";

import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/css";

import { toast } from "react-hot-toast";

import { useDispatch, useSelector } from "react-redux";
import { createLinkSettings } from "../../../../../redux/slices/appearance/createLinkSettingsSlice";
import {
  gettingSettingUpdataData,
  getScreenPreviewSetting,
} from "../../../../../redux/slices/appearance/appearanceSlice";
import { useNavigate } from "react-router-dom";
import useLocales from "../../../../../hooks/useLocales";
import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";
import AppearanceDeleteButton from "../../../../../components/common/buttons/AppearanceDeleteButton";

const animationTypes = [
  { value: "none", label: "None" },
  { value: "fade-up", label: "Fade Up" },
  { value: "fade-down", label: "Fade Down" },
  { value: "fade-left", label: "Fade Left" },
  { value: "fade-right", label: "Fade Right" },
  { value: "fade-up-right", label: "Fade Up Right" },
  { value: "fade-up-left", label: "Fade Up Left" },
  { value: "fade-down-right", label: "Fade Down Right" },
  { value: "fade-down-left", label: "Fade Down Left" },
  { value: "flip-up", label: "Flip Up" },
  { value: "flip-down", label: "Flip Down" },
  { value: "flip-left", label: "Flip Left" },
  { value: "flip-right", label: "Flip Right" },
  { value: "slide-up", label: "Slide Up" },
  { value: "slide-down", label: "Slide Down" },
  { value: "slide-left", label: "Slide Left" },
  { value: "slide-right", label: "Slide Right" },
  { value: "zoom-in", label: "zoom-in" },
  { value: "zoom-in-up", label: "zoom-in-up" },
  { value: "zoom-in-down", label: "zoom-in-down" },
  { value: "zoom-in-left", label: "zoom-in-left" },
  { value: "zoom-in-right", label: "zoom-in-right" },
  { value: "zoom-out", label: "zoom-out" },
  { value: "zoom-out-up", label: "zoom-out-up" },
  { value: "zoom-out-down", label: "zoom-out-down" },
  { value: "zoom-out-left", label: "zoom-out-left" },
  { value: "zoom-out-right", label: "zoom-out-right" },
];
const animationTimes = [
  "0.2s",
  "0.3s",
  "0.5s",
  "0.7s",
  "0.9s",
  "1s",
  "1.5s",
  "2s",
  "3s",
  "4s",
  "5s",
];
const outLineType = ["none", "dashed", "dotted", "double", "solid"];
const outLineWidth = ["none", "1px", "2px", "4px", "8px"];

const LinkAcc = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { translate } = useLocales();

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (width > 768) {
      navigate("/dashboard/appearance");
    }
    const sizeHandler = () => {
      setWidth(window.innerWidth);
      if (window.innerWidth > 768) {
        navigate("/dashboard/appearance");
      }
    };
    window.addEventListener("resize", sizeHandler);
    return () => {
      window.removeEventListener("resize", sizeHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [linkButtonBgColor, setLinkButtonBgColor] = useColor("#FFF");
  useEffect(() => {
    setLinkButtonBgColorHandler(linkButtonBgColor);
  }, [linkButtonBgColor]);

  const [linkButtonTextColor, setLinkButtonTextColor] = useColor("#1E1C1C");
  useEffect(() => {
    setLinkButtonTextColorHandler(linkButtonTextColor);
  }, [linkButtonTextColor]);

  const [linkOutlineColor, setLinkOutlineColor] = useColor("#CAFF");
  useEffect(() => {
    setLinkOutlineColorHandler(linkOutlineColor);
  }, [linkOutlineColor]);

  const [subLoading, setSubLoading] = useState(false);
  const outLineStyleDropDownRef = useRef();
  const outLineStyleDropDownBtnRef = useRef();
  const buttonBgColrDropDownRef = useRef();
  const buttonBgColrDropDownBtnRef = useRef();
  const buttonTextColrDropDownRef = useRef();
  const buttonTextColrDropDownBtnRef = useRef();
  const outlineColrDropDownRef = useRef();
  const outlineColrDropDownBtnRef = useRef();
  const outLineWidthDropDownRef = useRef();
  const outLineWidthDropDownBtnRef = useRef();
  const animationTypeDropDownRef = useRef();
  const animationTypeDropDownBtnRef = useRef();
  const animationRunsDropDownRef = useRef();
  const animationRunsDropDownBtnRef = useRef();
  const [selectedShape, setSelectedShape] = useState("");
  const [colorLinkOutline, setColorLinkOutline] = useState("#CAFF");

  const [selectedOutlineType, setSelectedOutlineType] = useState("");
  const [selectedOutlineWidth, setSelectedOutlineWidth] = useState("");
  const [outLineStlyDropdown, setOutLineStlyDropdown] = useState(false);
  const [outLineWidthDropdown, setOutLineWidthDropdown] = useState(false);

  const [selectedAnimationType, setSelectedAnimationType] = useState("");
  const [selectedAnimationRuns, setSelectedAnimationRuns] = useState("");
  const [animationTypeDropdown, setAnimationTypeDropdown] = useState(false);
  const [animationRunsDropdown, setAnimationRunsDropdown] = useState(false);

  const [openLinkOutlineColopicker, setOpenLinkOutlineColopicker] =
    useState(false);
  const setLinkOutlineColorHandler = (color) => {
    setColorLinkOutline(color.hex);
  };
  const [colorLinkButtonText, setColorLinkButtonText] = useState("#1E1C1C");
  const [openLinkButtonTextColopicker, setOpenLinkButtonTextColopicker] =
    useState(false);
  const setLinkButtonTextColorHandler = (color) => {
    setColorLinkButtonText(color.hex);
  };
  const [colorLinkButtonBg, setColorLinkButtonBg] = useState("#fff");
  const [openLinkButtonBgColopicker, setOpenLinkButtonBgColopicker] =
    useState(false);
  const setLinkButtonBgColorHandler = (color) => {
    setColorLinkButtonBg(color.hex);
  };

  // Button Bg color dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        openLinkButtonBgColopicker &&
        buttonBgColrDropDownRef.current &&
        !buttonBgColrDropDownRef.current.contains(e.target) &&
        !buttonBgColrDropDownBtnRef.current.contains(e.target)
      ) {
        setOpenLinkButtonBgColopicker(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openLinkButtonBgColopicker]);

  // Button Text color dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        openLinkButtonTextColopicker &&
        buttonTextColrDropDownRef.current &&
        !buttonTextColrDropDownRef.current.contains(e.target) &&
        !buttonTextColrDropDownBtnRef.current.contains(e.target)
      ) {
        setOpenLinkButtonTextColopicker(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openLinkButtonTextColopicker]);

  // Outline color dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        openLinkOutlineColopicker &&
        outlineColrDropDownRef.current &&
        !outlineColrDropDownRef.current.contains(e.target) &&
        !outlineColrDropDownBtnRef.current.contains(e.target)
      ) {
        setOpenLinkOutlineColopicker(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openLinkOutlineColopicker]);

  // outline style dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        outLineStlyDropdown &&
        outLineStyleDropDownRef.current &&
        !outLineStyleDropDownRef.current.contains(e.target) &&
        !outLineStyleDropDownBtnRef.current.contains(e.target)
      ) {
        setOutLineStlyDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outLineStlyDropdown]);

  // outline width dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        outLineWidthDropdown &&
        outLineWidthDropDownRef.current &&
        !outLineWidthDropDownRef.current.contains(e.target) &&
        !outLineWidthDropDownBtnRef.current.contains(e.target)
      ) {
        setOutLineWidthDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outLineWidthDropdown]);

  // animation type dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        animationTypeDropdown &&
        animationTypeDropDownRef.current &&
        !animationTypeDropDownRef.current.contains(e.target) &&
        !animationTypeDropDownBtnRef.current.contains(e.target)
      ) {
        setAnimationTypeDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animationTypeDropdown]);

  // animation runs dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        animationRunsDropdown &&
        animationRunsDropDownRef.current &&
        !animationRunsDropDownRef.current.contains(e.target) &&
        !animationRunsDropDownBtnRef.current.contains(e.target)
      ) {
        setAnimationRunsDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animationRunsDropdown]);

  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const linkId = localStorage?.getItem("linkId");
  const user = {
    userData: userId,
    linkData: linkId,
  };

  const LinkStyls = useSelector(
    (state) => state?.gettingAppearance?.gettingAppearance?.data?.response
  );

  useEffect(() => {
    LinkStyls?.map((item) => {
      if (item?.coloum_name === "link") {
        const value = JSON.parse(item.coloum_value);
        setSelectedShape(value?.link_shape);
        setColorLinkButtonBg(
          value?.link_colors?.link_button_bg_color || "#CAFF"
        );
        setLinkButtonBgColor((color) => {
          return {
            ...color,
            hex: value?.link_colors?.link_button_bg_color || "#FFF",
          };
        });
        setColorLinkButtonText(
          value?.link_colors?.link_button_font_color || "#1E1C1C"
        );
        setLinkButtonTextColor((color) => {
          return {
            ...color,
            hex: value?.link_colors?.link_button_font_color || "#1E1C1C",
          };
        });
        setSelectedOutlineType(value?.link_outline?.link_outline_Style);
        setSelectedOutlineWidth(value?.link_outline?.link_outline_width);
        setColorLinkOutline(
          value?.link_outline?.link_outline_colour || "#CAFF"
        );
        setLinkOutlineColor((color) => {
          return {
            ...color,
            hex: value?.link_outline?.link_outline_colour || "#CAFF",
          };
        });
        setSelectedAnimationType(value?.link_animation?.link_animation_type);
        setSelectedAnimationRuns(value?.link_animation?.link_animation_runs);
      }
      return null;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [LinkStyls]);

  const submitHandler = async () => {
    const userId = JSON.parse(localStorage.getItem("user"))?.userid;
    const pageName = JSON.parse(localStorage.getItem("user"))?.twofactor
      ?.pageName;
    const linkId = localStorage?.getItem("linkId");

    const formData = {
      link_shape: selectedShape,
      userId,
      linkId,
    };

    if (
      selectedShape &&
      selectedOutlineType &&
      selectedOutlineWidth &&
      selectedAnimationType &&
      selectedAnimationRuns &&
      colorLinkButtonBg &&
      colorLinkButtonText &&
      colorLinkOutline
    ) {
      formData.link_shape = selectedShape;
      formData.link_outline = {
        link_outline_Style: selectedOutlineType,
        link_outline_width: selectedOutlineWidth,
        link_outline_colour: colorLinkOutline,
      };
      formData.link_animation = {
        link_animation_type: selectedAnimationType,
        link_animation_runs: selectedAnimationRuns,
      };
      formData.link_colors = {
        link_button_bg_color: colorLinkButtonBg,
        link_button_font_color: colorLinkButtonText,
      };
      // console.log(formData, "link dataa");
      setSubLoading(true);

      await dispatch(createLinkSettings(formData)).then(() => {
        dispatch(getScreenPreviewSetting(pageName));
        dispatch(gettingSettingUpdataData(user));
      });

      setSubLoading(false);
    } else {
      toast.error("Please select all fields");
    }
  };

  const [deleteStylePending, setDeleteStylePending] = useState(false);

  const deleteHandler = async () => {
    setDeleteStylePending(true);
    const userId = JSON.parse(localStorage.getItem("user"))?.userid;
    const pageName = JSON.parse(localStorage.getItem("user"))?.twofactor
      ?.pageName;
    const linkId = localStorage?.getItem("linkId");

    const formData = {
      userId: userId,
      linkId: linkId,
    };
    setSelectedShape("");
    setColorLinkButtonBg("#CAFF");
    setColorLinkButtonText("#1E1C1C");
    setSelectedOutlineType("");
    setSelectedOutlineWidth("");
    setColorLinkOutline("#CAFF");
    setSelectedAnimationType("");
    setSelectedAnimationRuns("");
    await dispatch(createLinkSettings(formData)).then(() => {
      dispatch(gettingSettingUpdataData(user));
      dispatch(getScreenPreviewSetting(pageName));
    });

    setDeleteStylePending(false);
  };

  return (
    <div className="mt-[30px]">
      <div
        style={{
          boxShadow:
            "-2px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 6px 0px rgba(0, 0, 0, 0.02)",
        }}
        className="dark:border-color_dark border border-light_bg_v4 rounded-[9px] py-5 px-[20px] lg:px-[26px]"
      >
        <div className="text-small2 md:text-small1 mb-5 dark:text-color_v1_dark">
          {/*Shape */}
          {translate("shape")}
        </div>
        <div className="flex gap-5 items-start flex-col lg:flex-row">
          <div
            onClick={() => setSelectedShape("rounded")}
            className={`dark:text-[#292D32] w-full p-3 rounded-lg flex justify-center items-center text-center bg-[#fcdddb] text-small4 font-semibold md:font-bold md:text-small3_b cursor-pointer ${
              selectedShape === "rounded"
                ? "outline outline-1 outline-offset-[5px]"
                : ""
            }`}
          >
            {/* Rounded corners */}
            {translate("cms.rounded_corners")}
          </div>
          <div
            onClick={() => setSelectedShape("circle")}
            className={`dark:text-[#292D32] w-full p-3 rounded-full text-center bg-[#fcdddb] text-small4 font-semibold md:font-bold md:text-small3_b cursor-pointer ${
              selectedShape === "circle"
                ? "outline outline-1 outline-offset-[5px]"
                : ""
            }`}
          >
            {/* Full Rounded corners */}
            {translate("cms.full_rounded_corners")}
          </div>
          <div
            onClick={() => setSelectedShape("straight")}
            className={`dark:text-[#292D32] w-full p-3 text-center bg-[#fcdddb] text-small4 font-semibold md:font-bold md:text-small3_b cursor-pointer ${
              selectedShape === "straight"
                ? "outline outline-1 outline-offset-[5px]"
                : ""
            }`}
          >
            {/* Straight corners */}
            {translate("cms.straight_corners")}
          </div>
        </div>
      </div>
      <div
        style={{
          boxShadow:
            "-2px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 6px 0px rgba(0, 0, 0, 0.02)",
        }}
        className="dark:border-color_dark border border-light_bg_v4  rounded-[9px] mt-5 py-5 px-[20px] lg:px-[26px]"
      >
        <div className="text-small2 md:text-small1 mb-5 dark:text-color_v1_dark">
          {/* Color */}
          {translate("colors")}
        </div>
        <div className="flex gap-5 items-center flex-col lg:flex-row">
          <div className="relative flex items-center justify-start w-full ">
            <div
              ref={buttonBgColrDropDownBtnRef}
              onClick={() =>
                setOpenLinkButtonBgColopicker(!openLinkButtonBgColopicker)
              }
              style={{
                background: colorLinkButtonBg,
              }}
              className={`border rounded-md me-[16px] lg:me-[19px] cursor-pointer min-w-[48px] w-[48px] min-h-[48px] h-[48px] lg:min-w-[48px] lg:w-[48px] lg:min-h-[48px] lg:h-[48px] relative`}
            ></div>
            {openLinkButtonBgColopicker && (
              <div
                className="absolute top-0 w-full pb-5 "
                style={{ zIndex: "999999999" }}
              >
                <div
                  ref={buttonBgColrDropDownRef}
                  className="border bg-white shadow-xl rounded-lg p-3"
                >
                  <ColorPicker
                    color={linkButtonBgColor}
                    onChange={setLinkButtonBgColor}
                    hideInput={true}
                    height={150}
                  />
                  <div className="flex flex-wrap 2xl:flex-nowrap justify-center items-center -mt-[8px] gap-2 px-2">
                    <div className="flex justify-center items-center gap-1 w-full">
                      <div className="border rounded-md px-1 py-0.5 w-full text-center text-small2">
                        <p>HEX</p>
                      </div>
                      <p>:</p>
                      <div className="border rounded-md px-1 py-0.5 w-full text-center text-small2">
                        <p>{linkButtonBgColor?.hex}</p>
                      </div>
                    </div>
                    <div className="flex gap-1 justify-between w-full ">
                      <div className="border rounded-md px-1 py-0.5 text-small2">
                        {Math.round((linkButtonBgColor?.rgb?.a / 1) * 100)}%
                      </div>
                      <button
                        className="rounded-full px-3 text-small3_b leading-none cursor-pointer bg-main_color text-white hover:opacity-70"
                        onClick={() => setOpenLinkButtonBgColopicker(false)}
                      >
                        DONE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="w-full overflow-hidden">
              <div className="text-small3 md:text-small2 text-body_copy_medium_color dark:text-color_v2_dark z-10">
                {/* Button Background color */}
                {translate("cms.button_background_color")}
              </div>
              <div className="text-small2_b text-heading_color ">
                <input
                  value={colorLinkButtonBg}
                  type="text"
                  className="focus:outline-none z-0 bg-transparent -mt-[8px] dark:bg-dark-secondary dark:text-color_v1_dark"
                  onChange={(e) => {
                    setLinkButtonBgColor((color) => {
                      return { ...color, hex: e.target.value };
                    });
                  }}
                />
              </div>
            </div>
          </div>
          <div className="relative flex items-center justify-start w-full ">
            <div
              ref={buttonTextColrDropDownBtnRef}
              onClick={() =>
                setOpenLinkButtonTextColopicker(!openLinkButtonTextColopicker)
              }
              style={{
                background: colorLinkButtonText,
              }}
              className={`rounded-md border me-[16px] lg:me-[19px] cursor-pointer min-w-[48px] w-[48px] min-h-[48px] h-[48px] lg:min-w-[48px] lg:w-[48px] lg:min-h-[48px] lg:h-[48px] relative`}
            ></div>
            {openLinkButtonTextColopicker && (
              <div
                className="absolute top-0 w-full pb-5 "
                style={{ zIndex: "999999999" }}
              >
                <div
                  ref={buttonTextColrDropDownRef}
                  className="border bg-white shadow-xl rounded-lg p-3"
                >
                  <ColorPicker
                    color={linkButtonTextColor}
                    onChange={setLinkButtonTextColor}
                    hideInput={true}
                    height={150}
                  />
                  <div className="flex flex-wrap 2xl:flex-nowrap justify-center items-center -mt-[8px] gap-2 px-2">
                    <div className="flex justify-center items-center gap-1 w-full">
                      <div className="border rounded-md px-1 py-0.5 w-full text-center text-small2">
                        <p>HEX</p>
                      </div>
                      <p>:</p>
                      <div className="border rounded-md px-1 py-0.5 w-full text-center text-small2">
                        <p>{linkButtonTextColor?.hex}</p>
                      </div>
                    </div>
                    <div className="flex gap-1 justify-between w-full ">
                      <div className="border rounded-md px-1 py-0.5 text-small2">
                        {Math.round((linkButtonTextColor?.rgb?.a / 1) * 100)}%
                      </div>
                      <button
                        className="rounded-full px-3 text-small3_b leading-none cursor-pointer bg-main_color text-white hover:opacity-70"
                        onClick={() => setOpenLinkButtonTextColopicker(false)}
                      >
                        DONE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="w-full overflow-hidden">
              <div className="text-small3 md:text-small2 text-body_copy_medium_color dark:text-color_v2_dark">
                {/* Button Font color */}
                {translate("cms.button_font_color")}
              </div>
              <div className="text-small2_b text-heading_color dark:text-color_v2_dark ">
                <input
                  value={colorLinkButtonText}
                  type="text"
                  className="focus:outline-none bg-transparent -mt-[8px] dark:bg-dark-secondary dark:text-color_v1_dark"
                  onChange={(e) => {
                    setLinkButtonTextColor((color) => {
                      return { ...color, hex: e.target.value };
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          boxShadow:
            "-2px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 6px 0px rgba(0, 0, 0, 0.02)",
        }}
        className="dark:border-color_dark border border-light_bg_v4 rounded-[9px] mt-5 py-5 px-[20px] lg:px-[26px]"
      >
        <div className="text-small2 md:text-small1 mb-5 dark:text-color_v1_dark">
          {/* Outline */}
          {translate("cms.outline")}
        </div>
        <div className="relative">
          <div
            ref={outLineStyleDropDownBtnRef}
            onClick={() => setOutLineStlyDropdown(!outLineStlyDropdown)}
            className="relative cursor-pointer flex gap-2.5 p-[13px] lg:p-[11px] px-[14px] lg:px-[15px] justify-between items-center rounded-md bg-light_bg_v4 dark:bg-[#404040]"
          >
            <div className="flex justify-center items-center">
              {darkMode ? <OutlineDark /> : <Outline />}
            </div>
            <div className="w-full capitalize bg-transparent text-small2 lg:text-small1  dark:text-color_v1_dark">
              {selectedOutlineType
                ? selectedOutlineType
                : translate("cms.outline_style")}
            </div>
            <div className=" flex justify-center items-center">
              {darkMode ? <DownArrowIconDark /> : <DownArrowIcon />}
            </div>
          </div>
          {outLineStlyDropdown && (
            <div
              ref={outLineStyleDropDownRef}
              className="absolute top-12 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5 dark:bg-[#404040] rounded-lg border  flex flex-col max-h-44 shadow-lg overflow-y-auto"
            >
              {outLineType.map((item, i) => {
                return (
                  <div
                    key={i}
                    onClick={() => {
                      setSelectedOutlineType(item);
                      setOutLineStlyDropdown(false);
                    }}
                    className="px-[10] lg:px-[15px] py-[7px] text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark cursor-pointer hover:bg-light_bg_v4 dark:hover:bg-dark-secondary rounded-md "
                  >
                    <div
                      style={{ borderStyle: item }}
                      className={`w-full capitalize ${
                        item === "solid"
                          ? "border-2"
                          : item === "double"
                          ? "border-double border-4"
                          : "border-2 border-" + item
                      } border-heading_color dark:border-color_v2_dark p-1 lg:p-2 py-0.5 lg:py-1`}
                    >
                      {item}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className="relative">
          <div
            ref={outLineWidthDropDownBtnRef}
            onClick={() => setOutLineWidthDropdown(!outLineWidthDropdown)}
            className="relative cursor-pointer flex gap-2.5 p-[13px] lg:p-[11px] px-[14px] lg:px-[15px] justify-between items-center rounded-md bg-light_bg_v4 dark:bg-[#404040] mt-2.5"
          >
            <div className="flex justify-center items-center">
              {darkMode ? <BrushDark /> : <Brush />}
            </div>
            <div className="w-full capitalize bg-transparent text-small2 lg:text-small1 dark:text-color_v1_dark ">
              {selectedOutlineWidth
                ? selectedOutlineWidth
                : translate("cms.outline_width")}
            </div>
            <div className=" flex justify-center items-center">
              {darkMode ? <DownArrowIconDark /> : <DownArrowIcon />}
            </div>
          </div>
          {outLineWidthDropdown && (
            <div
              ref={outLineWidthDropDownRef}
              className="absolute top-12 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5 dark:bg-[#404040] rounded-lg border flex flex-col max-h-32 shadow-lg overflow-y-auto"
            >
              {outLineWidth.map((item, i) => {
                return (
                  <div
                    key={i}
                    onClick={() => {
                      setSelectedOutlineWidth(item);
                      setOutLineWidthDropdown(false);
                    }}
                    className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark cursor-pointer hover:bg-light_bg_v4 dark:hover:bg-dark-secondary rounded-md"
                  >
                    {item}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className="relative flex items-center justify-start w-full mt-5">
          <div
            ref={outlineColrDropDownBtnRef}
            onClick={() =>
              setOpenLinkOutlineColopicker(!openLinkOutlineColopicker)
            }
            style={{
              background: colorLinkOutline,
            }}
            className={`border rounded-md me-[16px] lg:me-[19px] cursor-pointer min-w-[48px] w-[48px] min-h-[48px] h-[48px] lg:min-w-[48px] lg:w-[48px] lg:min-h-[48px] lg:h-[48px] relative`}
          ></div>
          {openLinkOutlineColopicker && (
            <div
              className="absolute top-0 lg:w-[80%] 2xl:w-[60%] w-full pb-5 "
              style={{ zIndex: "999999999" }}
            >
              <div
                ref={outlineColrDropDownRef}
                className="border bg-white shadow-xl rounded-lg p-3 "
              >
                <ColorPicker
                  color={linkOutlineColor}
                  onChange={setLinkOutlineColor}
                  hideInput={true}
                  height={150}
                />
                <div className="flex flex-wrap xl:flex-nowrap justify-center items-center -mt-[8px] gap-2 px-2">
                  <div className="flex justify-center items-center gap-1 w-full">
                    <div className="border rounded-md px-1 py-0.5 w-full text-center text-small2">
                      <p>HEX</p>
                    </div>
                    <p>:</p>
                    <div className="border rounded-md px-1 py-0.5 w-full text-center text-small2">
                      <p>{linkOutlineColor?.hex}</p>
                    </div>
                  </div>
                  <div className="flex gap-1 justify-between w-full ">
                    <div className="border rounded-md px-1 py-0.5 text-small2">
                      {Math.round((linkOutlineColor?.rgb?.a / 1) * 100)}%
                    </div>
                    <button
                      className="rounded-full px-3 text-small3_b leading-none cursor-pointer bg-main_color text-white hover:opacity-70"
                      onClick={() => setOpenLinkOutlineColopicker(false)}
                    >
                      DONE
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="w-full overflow-hidden">
            <div className="text-small3 md:text-small2 text-body_copy_medium_color dark:text-color_v1_dark">
              {/* Color */}
              {translate("color")}
            </div>
            <div className="text-small2_b text-heading_color dark:text-color_v1_dark">
              <input
                value={colorLinkOutline}
                type="text"
                className="focus:outline-none bg-transparent -mt-[8px]"
                onChange={(e) => {
                  setLinkOutlineColor((color) => {
                    return { ...color, hex: e.target.value };
                  });
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          boxShadow:
            "-2px 2px 4px 0px rgba(0, 0, 0, 0.08), 0px 0px 6px 0px rgba(0, 0, 0, 0.02)",
        }}
        className="dark:border-color_dark border border-light_bg_v4 rounded-[9px] mt-5 py-5 px-[20px] lg:px-[26px]"
      >
        <div className="text-small2 md:text-small1 mb-5 dark:text-color_v1_dark">
          {/* Animation */}
          {translate("animation")}
        </div>
        <div className="relative">
          <div
            ref={animationTypeDropDownBtnRef}
            onClick={() => setAnimationTypeDropdown(!animationTypeDropdown)}
            className="relative cursor-pointer flex gap-2.5 p-[13px] lg:p-[11px] px-[14px] lg:px-[15px] justify-between items-center rounded-md bg-light_bg_v4 dark:bg-[#404040]"
          >
            <div className="flex justify-center items-center">
              {darkMode ? <AnimationTypeDark /> : <AnimationType />}
            </div>
            <div className="w-full capitalize bg-transparent text-small2 lg:text-small1 dark:text-color_v1_dark">
              {selectedAnimationType
                ? selectedAnimationType.label
                : "Animation Type"}
            </div>
            <div className=" flex justify-center items-center">
              {darkMode ? <DownArrowIconDark /> : <DownArrowIcon />}
            </div>
          </div>
          {animationTypeDropdown && (
            <div
              ref={animationTypeDropDownRef}
              className="absolute top-12 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5 dark:bg-[#404040] rounded-lg border flex flex-col max-h-36 overflow-y-auto shadow-lg"
            >
              {animationTypes.map((item, i) => {
                return (
                  <div
                    key={i}
                    onClick={() => {
                      setSelectedAnimationType(item);
                      setAnimationTypeDropdown(false);
                    }}
                    className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark cursor-pointer hover:bg-light_bg_v4 dark:hover:bg-dark-secondary rounded-md"
                  >
                    {item.label}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className="relative">
          <div
            ref={animationRunsDropDownBtnRef}
            onClick={() => setAnimationRunsDropdown(!animationRunsDropdown)}
            className="relative cursor-pointer flex gap-2.5 p-[13px] lg:p-[11px] px-[14px] lg:px-[15px] justify-between items-center rounded-md bg-light_bg_v4 dark:bg-[#404040] mt-2.5"
          >
            <div className="flex justify-center items-center">
              {darkMode ? <AnimationRunsDark /> : <AnimationRuns />}
            </div>
            <div className="w-full capitalize bg-transparent dark:bg-[#404040] dark:text-color_v1_dark text-small2 lg:text-small1">
              {selectedAnimationRuns ? selectedAnimationRuns : "Animation Runs"}
            </div>
            <div className=" flex justify-center items-center">
              {darkMode ? <DownArrowIconDark /> : <DownArrowIcon />}
            </div>
          </div>
          {animationRunsDropdown && (
            <div
              ref={animationRunsDropDownRef}
              className="absolute top-12 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5 dark:bg-[#404040] rounded-lg border flex flex-col max-h-32 overflow-y-auto shadow-lg"
            >
              {animationTimes.map((item, i) => {
                return (
                  <div
                    key={i}
                    onClick={() => {
                      setSelectedAnimationRuns(item);
                      setAnimationRunsDropdown(false);
                    }}
                    className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color dark:text-color_v1_dark cursor-pointer hover:bg-light_bg_v4 dark:hover:bg-dark-primary rounded-md"
                  >
                    {item}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
      <div className="flex mt-[25px] items-center justify-end">
        <AppearanceDeleteButton
          isLoading={deleteStylePending}
          onClickHandler={deleteHandler}
        />

        {/* <button
          onClick={() => submitHandler()}
          className={`ms-3 rounded-full flex p-1.5 px-[22px] bg-main_color text-white text-small3_b ${
            subLoading ? "opacity-70" : ""
          } `}
        >
          {subLoading ? (
            <svg
              aria-hidden="true"
              role="status"
              className="inline w-3 h-3 text-white animate-spin"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="#E5E7EB"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentColor"
              />
            </svg>
          ) : (
            "SAVE"
          )}
          </button> */}
        <ExtraSmallFilledButton
          name={`${translate("biolink_title.save_cap")}`}
          buttonType={"button"}
          isLoading={subLoading}
          onClickHandler={submitHandler}
          classes={"ms-3"}
        />
      </div>
    </div>
  );
};

export default LinkAcc;
